import React from 'react';
import PropTypes from 'prop-types';
import ErrorBoundary from 'core/components/ErrorBoundary';
import { CartProvider } from 'core/providers/CartContext';
import { MpOrderProvider } from 'core/providers/MpOrderContext';
import { ProcessorProvider } from 'core/providers/ProcessorContext';
import { MultiGiftingProvider } from 'core/providers/MultiGiftingContext';


/**
 * Entry container for top of checkout React tree.
 * child node is wrapped with ErrorBoundary, CartProvider & MpOrderProvider
 *
 * @param {Number} cartId - Id of cart to stage for order. When none, stage all carts
 * @param {Number} mpOrderId - Id of completed mp_order during checkout
 * @param {Component} children - Page-container, top of the tree
 */
const CheckoutEntryContainer = ({ children, cartId, mpOrderId }) => {
	return (
		<ErrorBoundary>
			<CartProvider value={{ activeCartId: cartId, multicart: !cartId, checkout: true }}>
				{/* Processor must be inside CartProvider */}
				<ProcessorProvider value={{ complete: !!mpOrderId }}>
					{/* MpOrder must be inside ProcessorProvider */}
					<MpOrderProvider value={{ mpOrderId: mpOrderId }}>
						<MultiGiftingProvider>
							{ children }
						</MultiGiftingProvider>
					</MpOrderProvider>
				</ProcessorProvider>
			</CartProvider>
		</ErrorBoundary>
	);
};

CheckoutEntryContainer.defaultProps = {
	children: null,
	cartId: null,
	mpOrderId: null,
};

CheckoutEntryContainer.propTypes = {
	children: PropTypes.node,
	cartId: PropTypes.number,
	mpOrderId: PropTypes.number,
};

export default CheckoutEntryContainer;
